<template>
  <div class="app-root">
    <Navbar />
    <main>
      <router-view />
    </main>
    <Footer />
    <Toast position="bottom-left" />
    <AdminIntelChat />
  </div>
</template>

<script setup>
import Navbar from "@/layouts/Navbar.vue"
import Footer from "@/layouts/Footer.vue"
import Toast from "primevue/toast"
import AdminIntelChat from "@/components/admin/AdminIntelChat.vue"
</script>

<style>
.app-root,
body {
  margin: 0;
  font-family: "Lato", sans-serif;
  direction: rtl;
  text-align: right;
}
main {
  min-height: 80vh;
  padding: 2rem;
}
</style>
